import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { mediaUrl } from 'kts-platform-frame/entry/configUtils';
import { Link } from 'react-router-dom';
import { Tag, Divider, Row, Col } from 'antd';
import { Urls } from 'kts-platform-frame/entry/constant';

const css = require('./index.scss');
const appDefault = require('../img/appDefault.png');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    loadingUrls?: Map<Urls, string>;
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loadingUrls: state.system.loadingUrls,
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const loadingUrls = this.props.loadingUrls;
        return (
            <div className={css.appList}>
                {this.getList()}
                {
                    !this.modulesState.appList.length && loadingUrls.size <= 0 &&
                    <p style={{ paddingTop: '130px', fontSize: '16px', textAlign: 'center' }}>暂无数据</p>
                }
            </div>
        );
    }
    /** 渲染列表 */
    private getList() {
        const appArr = [];
        const appList = this.modulesState.appList;
        const imgHost = mediaUrl();
        appList.forEach((item: any) => {
            appArr.push(
                <div className={css.appItem} key={item.appId}>
                    <Row style={{ height: 82 }}>
                        <Col span={18}>
                            <div className={css.itemLeft}>
                                <div>
                                    <Link to={`/workbench/platform/appStore/appDetail/${item.appKey}`}>
                                        {item.appIcon ? <img className={css.itemImg} src={imgHost + item.appIcon} /> : <img className={css.itemImg} src={appDefault} />}
                                    </Link>
                                </div>
                                <div className={css.itemTitle}>
                                    <div className={css.appName}>{item.appName}</div>
                                    <div className={css.appType}>{item.categoryName && item.categoryName.replace(/,/g, ' ')}</div>
                                </div>
                            </div>
                        </Col>
                        <Col span={6}>
                            <div className={css.itemRight}>
                                <Link to={`/workbench/platform/appStore/appDetail/${item.appKey}`}>
                                    {
                                        item.isActivated === 0 && <Tag color="#0066CC" >激活</Tag>

                                    }
                                    {
                                        item.isActivated === 1 && <Tag color="#DCDFE6" style={{ color: '#8492A6' }}>详情</Tag>
                                    }
                                </Link>
                            </div>
                        </Col>
                    </Row>
                    <Divider style={{ margin: '8px 0' }} />
                    <div className={css.itemDetail}>
                        {item.appDescription}
                    </div>
                </div>
            );
        });
        return appArr;
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManagement/UI.AppList.tsx